 <template>
  <div class="wrap">
    <div class="header" @click="Jump(list)">
      <div class="title">
        <div class="titleName">商品列表</div>
        <div class="orderState">{{list.state_text}}</div>
      </div>
      <div class="orderMsg">
        <div class="orderId">订单号:{{list.order_no}}</div>
        <div class="orderTime">{{list.create_time}}</div>
      </div>
    </div>
    <div class="content" @click="Jump(list)">
      <div class="orderImg" v-for="(item,index) in list.img" :key="index">
        <img :src="item | thumbnail(176,176)">
      </div>
      <p>
        共{{list.total_num}}件
        <i class="iconfont icon-gengduo"/>
      </p>
    </div>
    <div class="footers">
      <p class="total">
        合计:
        <span>￥{{list.total_price}}</span>
      </p>
      <div class="footerBtn">
        <slot name="footerBtn"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:["list"],
  methods:{
    Jump(list){
      this.$emit("Jump",list.id)
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../style/skin.less");
.wrap {
  margin-top: 12px;
  background: @white;
  .header{
    border-bottom: 1px solid @veryLightLine;
    .title{
      padding: 8px 15px;
      overflow: hidden;
      height: 30px;
      .titleName{
        float: left;
        font-size: 14px;
        color: @darkP;
        line-height: 20px;
      }
      .orderState{
        float: right;
        font-size: 16px;
        color: @text;
        line-height: 20px;
      }
    }
    .orderMsg{
      padding: 8px 15px;
      overflow: hidden;
      .orderId{
        float: left;
        font-size: 12px;
        color: @lightP;
      }
      .orderTime{
        float: right;
        font-size: 12px;
        color: @lightP;
      }
    }
  }
  .content{
    padding: 8px 15px;
    overflow: hidden;
    border-bottom: 1px solid @veryLightLine;
    .orderImg{
      width: 80px;
      height: 80px;
      float: left;
      img{
        width: 100%;
        height: 100%;
      }
    }
    p{
      float:right;
      line-height: 80px;
      font-size: 14px;
      color: @lightP;
    }
  }
  .footers{
    padding: 8px 10px;
    overflow: hidden;
    .total{
      float: left;
      font-size: 14px;
      span{
        color: @text;
      }
    }
    .footerBtn{
      float: right;
    }
  }
}
</style>